import React, { useRef, useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { settingService } from "../../../services/extensions";
import { InputText } from "primereact/inputtext";
import { Util } from "../../../services";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import AddLegalEntityForm from "./legal-entity-form";
import ImportPopup from "../importpopup/importPop";
import { confirmDialog } from "primereact/confirmdialog";
import { SplitButton } from "primereact/splitbutton";

function LegalEntity() {
  const [legalEntities, setLegalEntities] = useState([]);
  const [legalEntityDialog, setLegalEntityDialog] = useState(false);
  const [importDialog, setImportDialog] = useState(false);
  const dt = useRef(null);
  const [selectedLegalEntity, setSelectedLegalEntity] = useState([]);
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    getLegalEntity();
  }, []);

  const getLegalEntity = () => {
    settingService.getLegalEntity().then((resp) => {
      setLegalEntities(resp.data.data);
    });
  };

  const fetchStatus = (status) => {
    if (status === 0) return "INACTIVE";
    if (status === 1) return "ACTIVE";
    if (status === 2) return "REJECT";
    if (status === 3) return "UPCOMING";
    if (status === 4) return "ARCHIVE";
  };

  const fetchStatusColor = (status) => {
    if (status === 0) return "red";
    if (status === 1) return "#008000";
    if (status === 2) return "red";
    if (status === 3) return "#cb7205";
    if (status === 4) return "rgb(222 204 90)";
  };

  const statusBodyTemplate = (data) => {
    return (
      <span style={{ color: fetchStatusColor(data.status), borderRadius: "8px", fontSize: "12px", fontWeight: "700" }}>{fetchStatus(data.status)}</span>
    );
  };

  const addLegalEntity = () => {
    setLegalEntityDialog(true);
  };

  const onHide = () => {
    setLegalEntityDialog(false);
  };

  const closeEntityDialoge = () => {
    setLegalEntityDialog(false);
    getLegalEntity();
  };

  const NewLegalEntityDialog = () => {
    return (
      <Dialog
        // style={{ width: "30vw" }}
        className="modal_width"
        header="Add Legal Entity"
        visible={legalEntityDialog}
        onHide={() => onHide()}>
        <AddLegalEntityForm
          onClose={(e) => {
            closeEntityDialoge();
          }} />
      </Dialog>
    );
  };
  const onClickDeallocation = (rowData) => {
    setImportDialog(true);
  };
  const onHideImport = () => {
    setImportDialog(false);
  };

  const OpenimportDialog = () => {
    return (
      <Dialog
        className="pop-up-dialog"
        header="Import"
        footer={<Button label="Submit"></Button>}
        visible={importDialog}
        onHide={() => onHideImport()}>
        <ImportPopup
          onClose={(e) => {
            setImportDialog(false);
          }}
          type="legalEntity" />
      </Dialog>
    );
  };

  const exportExcel = () => {
    Util.exportExcel(legalEntities, "Legal_Entity");
  };

  const exportCSV = () => {
    dt.current.exportCSV(legalEntities, "Legal_Entity");
  };

  const cols = [
    { field: "id", header: "Id" },
    { field: "code", header: "Code" },
    { field: "title", header: "Title" },
    { field: "status", header: "Status" },
  ];

  const exportColumns = cols.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const exportPdf = () => {
    Util.exportAsPdf(exportColumns, legalEntities, "Legal_Entity");
  };

  const items = [
    {
      label: "CSV",
      icon: "pi pi-file-export",
      command: () => {
        exportCSV();
      },
    },
    {
      label: "EXCEL",
      icon: "pi pi-file-excel",
      command: () => {
        exportExcel();
      },
    },
    {
      label: "PDF",
      icon: "pi pi-file-pdf",
      command: () => {
        exportPdf();
      },
    },
  ];

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button
          label="New"
          icon="pi pi-plus"
          className="p-button mr-2"
          onClick={() => addLegalEntity()}
        ></Button>
        <Button
          type="button"
          label="Delete"
          icon="pi pi-trash"
          className="p-button-danger"
          disabled={disabled}
          onClick={deleteConfirm}
        ></Button>
      </React.Fragment>
    );
  };

  const rightToolbarTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          label="Import"
          icon="pi pi-plus"
          className="mr-2"
          onClick={() => {
            onClickDeallocation(rowData);
          }} />
        <SplitButton
          label="Export"
          icon="pi pi-download"
          className="p-button-info"
          model={items}
          appendTo="self" />
      </React.Fragment>
    );
  };

  const editRowComplete = (e) => {
    let _legalEntity = [...legalEntities];
    let { newData, index } = e;
    _legalEntity[index] = newData;

    let param = {
      id: _legalEntity[index].id,
      code: _legalEntity[index].code,
      title: _legalEntity[index].title,
      status: _legalEntity[index].status,
    };

    try {
      settingService.updateLegalEntity(param).then(
        (resp) => {
          if (resp) {
            toast.success("Legal entity updated successfully!");
            getLegalEntity();
          }
        },
        (err) => {
          toast.error("Unable to update legal entity");
        }
      );
    } catch (error) {
      toast.error("Unable to update legal entity");
    }
  };

  const codeEditor = (options) => {
    return (
      <InputText value={options.value} onChange={(e) => options.editorCallback(e.target.value.toUpperCase())}></InputText>
    );
  };

  const titleEditor = (options) => {
    return (
      <InputText value={options.value} onChange={(e) => options.editorCallback(e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1))}></InputText>
    );
  };

  const statuses = [
    { label: "INACTIVE", value: 0 },
    { label: "ACTIVE", value: 1 },
    { label: "ARCHIVE", value: 4 },
  ];

  const statusEditor = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={statuses}
        optionLabel="label"
        optionValue="value"
        onChange={(e) => options.editorCallback(e.value)}
        placeholder="Select a Status"
        itemTemplate={(option) => {
          return (
            <span className={`product-badge status-${option.label.toLowerCase()}`}>{option.label}</span>
          );
        }} />
    );
  };

  const deleteLegalEntity = (e, row) => {
    confirmDialog({
      target: e.currentTarget,
      message: "Are you sure you want to delete?",
      header: "Delete Confirmation",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "No",
      rejectLabel: "Yes",
      reject: () => {
        settingService.deleteLegalEntityById(row.id).then(
          (resp) => {
            toast.success("Legal entity deleted successfully!");
            getLegalEntity();
          },
          (error) => { }
        );
      },
      accept: () => { },
    });
  };

  const deleteLegalEntityByRow = (row) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-danger"
          onClick={(e) => deleteLegalEntity(e, row)}
        ></Button>
      </React.Fragment>
    );
  };

  const onCheckLegalEntity = (e) => {
    setSelectedLegalEntity(e.value);
    if (e.value.length > 0) {
      setDisabled(false);
    }
  };

  /* FOR CONFIRMATION DIAGOG BOX */
  const [isConfirmDialogVisiable, setIsConfirmDialogVisiable] = useState(false);
  const reject = () => {
    setIsConfirmDialogVisiable(true);
  };
  /* FOR CONFIRMATION DIALOG BOX */

  const deleteConfirm = () => {
    confirmDialog({
      message: "Do you want to delete this record?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-danger",
      accept: () => acceptFunc(),
      reject,
    });
  };

  const acceptFunc = () => {
    var entityIdList = [];
    selectedLegalEntity.map((item, key) => {
      // entityIdList.push(item.id);
      entityIdList[key] = item.id;
    });
    let param = {
      Ids: entityIdList,
    };
    try {
      settingService.deleteAllLegalEntity(param).then(
        (resp) => {
          toast.success("Legal entity deleted");
          setSelectedLegalEntity([]);
          getLegalEntity();
        },
        (err) => {
          toast.error(err.response.data.error);
          setSelectedLegalEntity([]);
        }
      );
    } catch (error) {
      toast.error("Unable to delete legal entiry");
    }
  };

  return (
    <div>
      <Toolbar
        className="mb-2"
        left={leftToolbarTemplate}
        right={rightToolbarTemplate}
      ></Toolbar>
      <div className="grid">
        <div className="col-12">
          <DataTable
            value={legalEntities}
            paginator
            responsiveLayout="scroll"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={10}
            rowsPerPageOptions={[10, 20, 50]}
            dataKey="id"
            editMode="row"
            onRowEditComplete={editRowComplete}
            ref={dt}
            selectionMode="checkbox"
            selection={selectedLegalEntity}
            onSelectionChange={(e) => onCheckLegalEntity(e)}>
            <Column
              selectionMode="multiple"
              headerStyle={{ width: "3rem" }}
              exportable={false}
            ></Column>
            <Column
              field="code"
              header="Code"
              headerStyle={{ width: "8rem" }}
              editor={(options) => codeEditor(options)}
              sortable
            ></Column>
            <Column
              field="title"
              header="Title"
              headerStyle={{ width: "8rem" }}
              sortable
              editor={(options) => titleEditor(options)}
            ></Column>
            <Column
              field="status"
              header="Status"
              body={statusBodyTemplate}
              editor={(options) => statusEditor(options)}
              style={{ width: "20%" }}
            ></Column>
            <Column
              rowEditor
              headerStyle={{ width: "10%", minWidth: "8rem" }}
              bodyStyle={{ textAlign: "right" }}
            ></Column>
            <Column
              style={{ minWidth: "8rem" }}
              body={deleteLegalEntityByRow}
              exportable={false}
              rowEditor
              headerStyle={{ width: "10%", minWidth: "8rem" }}
            ></Column>
          </DataTable>
        </div>
      </div>
      {OpenimportDialog()}
      {NewLegalEntityDialog()}
    </div>
  );
}

export default LegalEntity;